// import { GET } from "../base-services";
import {
    Api_Response,
    Base_Filter,
    DELETE,
    GET,
    IBase_Entity,
    PATCH,
    POST,
} from "../base-services";

export class User_Service implements IUser_Service {
    static url = "/user";
    static instance: User_Service;

    static get_instance() {
        if (User_Service.instance) return User_Service.instance;
        else {
            User_Service.instance = new User_Service();
            return User_Service.instance;
        }
    }

    create_user = async (
        new_user: INew_User,
        org_code: string,
        api_key: string
    ) =>
        User_Service.get_instance().create_users([new_user], org_code, api_key);

    create_users = async (
        new_users: INew_User[],
        org_code: string,
        api_key: string
    ) =>
        POST<Create_User_Response>(
            `/user`,
            new_users,
            {},
            { "x-org": org_code, authorization: `Bearer ${api_key}` }
        );

    get_users = async (org: string, api_key: string, filter: any) =>
        org
            ? GET<Get_Users_Response>(`/user`, filter, {
                  "x-org": org,
                  authorization: `Bearer ${api_key}`,
                  device: filter.device,
                  verfied: filter.verfied,
              })
            : Promise.reject([
                  null,
                  { success: false, message: "Organization code is required." },
              ]);

    get_existing_pin = async (org: string, filter: any) =>
        org
            ? GET<any>(`/user/last-pin`, filter, {
                  "x-org": org,
              })
            : Promise.reject([
                  null,
                  { success: false, message: "Organization code is required." },
              ]);

    update_user = async (
        branch_id: string,
        pin: IUser_Row["pin"],
        org: string,
        updates: Partial<INew_User>,
        api_key: string
    ) =>
        PATCH<Update_Users_Response>(
            `/user`,
            updates,
            { branchId: branch_id, pin },
            { "x-org": org, authorization: `Bearer ${api_key}` }
        );

    delete_user = async (
        branch_id: string,
        userId: string,
        pin: IUser_Row["pin"],
        org: string,
        api_key: string
    ) =>
        DELETE<Delete_User_Response>(
            `/user`,
            "",
            { branchId: branch_id, pin, userId },
            { "x-org": org, authorization: `Bearer ${api_key}` }
        );
}

export enum User_Verification_Status {
    "Verified" = 1,
    "Pending" = 0,
}

export interface INew_User {
    pin?: number;
    name: string;
    branch: number;
    card?: string;
    password?: string;
    group: number;
    privilege: number;
    disabled: number;
    verified: User_Verification_Status;
}

export interface IUser_Row extends IBase_Entity, INew_User {
    // pin: 1;
    id: string;
    pin: number;
    // name: string;
    // card: "0";
    card: string;
    // password: string;
    // group: 1;
    // privilege: 14;
    // disabled: 0;
    // verfied: 0;
    group: number;
    privilege: number;
    disabled: 0 | 1;
    // verfied: User_Verification_Status;
    image: string;
}

type Get_Users_Response = Api_Response<{
    success: true;
    message: string;
    rows: IUser_Row[];
    count: number;
}>;

type Update_Users_Response = Api_Response<{ success: true; message: string }>;
type Delete_User_Response = Api_Response<{ success: true; message: string }>;

interface IUser_Service {
    create_user: (
        new_user: INew_User,
        org_code: string,
        org_api_key: string
    ) => Promise<Create_User_Response>;

    create_users: (
        new_users: INew_User[],
        org_code: string,
        org_api_key: string
    ) => Promise<Create_User_Response>;

    get_users: (
        org: string,
        api_key: string,
        filter: Get_Users_Filter
    ) => Promise<Get_Users_Response>;

    update_user: (
        branch_id: string,
        pin: IUser_Row["pin"],
        org: string,
        updates: Partial<INew_User>,
        api_key: string
    ) => Promise<Update_Users_Response>;

    delete_user: (
        branch_id: string,
        userId: string,
        pin: IUser_Row["pin"],
        org: string,
        api_key: string
    ) => Promise<Delete_User_Response>;
}

type Create_User_Response = Api_Response<{
    success: true;
    message: string;
}>;

type Get_Users_Filter = Base_Filter;
